// Shared polling helper (HS-98).
//
// Drop-in replacement for `setInterval(fn, ms)` used by the async-job panels'
// poll loops: it skips ticks while the browser tab is hidden, so a backgrounded
// tab stops hitting the backend. The interval still exists (so the panels'
// existing `pollRef.current` guard and `clearInterval(pollRef.current)` cleanup
// keep working unchanged) — it just no-ops its callback while hidden, and
// resumes on the next tick once the tab is visible again.
//
// This is the low-risk half of the polling consolidation: it centralizes the
// visibility-gating without restructuring each panel's loadStatus / startPolling
// / lifecycle logic. (A fuller useJobPolling hook that also de-duplicates the
// per-panel pollRef/startPolling/stopPolling boilerplate is a separate follow-up.)
export function pollingInterval(fn, ms) {
  return setInterval(() => {
    if (document.visibilityState === 'visible') fn();
  }, ms);
}
